import { render } from "./BackerCenterRecentlyViewedProjectsSection.vue?vue&type=template&id=07d8e99e"
import script from "./BackerCenterRecentlyViewedProjectsSection.vue?vue&type=script&lang=js"
export * from "./BackerCenterRecentlyViewedProjectsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__